import MilesPointsContent from "./MilesPointsContent";
import MilesPointsTab from "./MilesPointsTab";

function MilesPointsPage() {
  return (
    <div className="w-full sm:px-4 lg:px-10 sm:py-10 flex flex-col flex-1 font-main bg-[#F3F5F9]">
      <MilesPointsTab />
      <hr className="w-full my-4 border broder-[#DBDBDB]" />
      <MilesPointsContent />
    </div>
  );
}

export default MilesPointsPage;
